import { interpolate, SharedValue, useDerivedValue, withSpring } from 'react-native-reanimated';

interface UseCollapsibleHeaderParams {
  scrollOffset: SharedValue<number>;
  maxHeaderHeight: number;
  minHeaderHeight: number;
  springConfig?: Parameters<typeof withSpring>[1];
}

export const useCollapsibleHeader = ({
  scrollOffset,
  maxHeaderHeight,
  minHeaderHeight,
  springConfig = {
    damping: 25,
    stiffness: 160,
    restDisplacementThreshold: 0.1,
    restSpeedThreshold: 0.1
  }
}: UseCollapsibleHeaderParams) => {
  const animatedHeight = useDerivedValue(() => {
    const rawHeight = maxHeaderHeight - scrollOffset.value;
    const clampedHeight = Math.min(Math.max(rawHeight, minHeaderHeight), maxHeaderHeight);
    return withSpring(clampedHeight, springConfig);
  });

  const TOLERANCE = 20;

  const showExtra = useDerivedValue(() => {
    return animatedHeight.value >= maxHeaderHeight - TOLERANCE;
  });

  const progress = useDerivedValue(() => {
    return interpolate(animatedHeight.value, [minHeaderHeight, maxHeaderHeight], [0, 1], 'clamp');
  });

  return {
    animatedHeight,
    showExtra,
    progress
  };
};
